import { useState, useMemo } from "react";
import { useCountDailyOperatingVehiclesQuery } from "../preoperative/hooks/useCountDailyOperatingVehiclesQuery.js";
import CardNumber from "../../common/components/CardNumber.jsx";
import Textfield from "../../common/components/Textfiled";
import moment from "moment";

const FILTER_TYPES = [
  { value: "day", label: "Día" },
  { value: "month", label: "Mes" },
  { value: "range", label: "Rango personalizado" },
];

function NumberOfTrips() {
  const [filterType, setFilterType] = useState("day");
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [selectedMonth, setSelectedMonth] = useState(
    moment().format("YYYY-MM")
  );
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const filters = useMemo(() => {
    if (filterType === "day") {
      return { startDate: selectedDate, endDate: selectedDate };
    }
    if (filterType === "month") {
      const start = moment(selectedMonth, "YYYY-MM")
        .startOf("month")
        .format("YYYY-MM-DD");
      const end = moment(selectedMonth, "YYYY-MM")
        .endOf("month")
        .format("YYYY-MM-DD");
      return { startDate: start, endDate: end };
    }
    return { startDate, endDate };
  }, [filterType, selectedDate, selectedMonth, startDate, endDate]);

  const { countDailyOperatingVehicles } =
    useCountDailyOperatingVehiclesQuery(filters);

  const filterLabel = useMemo(() => {
    if (filterType === "day") {
      return `Día: ${moment(selectedDate).format("DD/MM/YYYY")}`;
    }
    if (filterType === "month") {
      return `Mes: ${moment(selectedMonth, "YYYY-MM").format("MMMM YYYY")}`;
    }
    return `Desde ${moment(startDate).format("DD/MM/YYYY")} hasta ${moment(endDate).format("DD/MM/YYYY")}`;
  }, [filterType, selectedDate, selectedMonth, startDate, endDate]);

  return (
    <main>
      <header className="text-center my-1">
        <h1 className="fs-1">Número de desplazamientos</h1>
      </header>

      <section className="d-flex flex-column align-items-center">
        <div className="d-flex gap-4 align-items-start flex-wrap justify-content-center mb-3">
          <div className="mb-3">
            <label className="form-label">Consultar por</label>
            <select
              className="form-select"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              {FILTER_TYPES.map((ft) => (
                <option key={ft.value} value={ft.value}>
                  {ft.label}
                </option>
              ))}
            </select>
          </div>

          {filterType === "day" && (
            <Textfield
              label="Fecha"
              type="date"
              name="selectedDate"
              value={selectedDate}
              onChange={({ value }) => setSelectedDate(value)}
            />
          )}

          {filterType === "month" && (
            <div className="mb-3">
              <label className="form-label">Mes</label>
              <input
                className="form-control"
                type="month"
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(e.target.value)}
              />
            </div>
          )}

          {filterType === "range" && (
            <>
              <Textfield
                label="Fecha inicio"
                type="date"
                name="startDate"
                value={startDate}
                onChange={({ value }) => setStartDate(value)}
              />
              <Textfield
                label="Fecha fin"
                type="date"
                name="endDate"
                value={endDate}
                onChange={({ value }) => setEndDate(value)}
              />
            </>
          )}
        </div>

        <p className="text-muted mb-3">
          <small>
            <strong>Filtro aplicado:</strong> {filterLabel}
          </small>
        </p>

        <div className="d-flex justify-content-around w-75">
          <CardNumber
            label="Vehículos que operan diariamente"
            number={countDailyOperatingVehicles}
          />
          <CardNumber
            label="Viajes laborales en vehículos medidos"
            number={countDailyOperatingVehicles}
          />
        </div>
      </section>
    </main>
  );
}

export default NumberOfTrips;
